import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function AuthorsSection() {
  return <section id="autores" className="relative w-full py-24 sm:py-32" data-id="element-14">
      {/* Background accent */}
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-purple-electric/[0.03] rounded-full blur-[120px] pointer-events-none" data-id="element-15" />
      <div className="absolute top-1/3 right-0 w-[300px] h-[300px] bg-gold/[0.03] rounded-full blur-[100px] pointer-events-none" data-id="element-16" />

      <div className="relative max-w-6xl mx-auto px-6" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-16" data-id="element-18">
          <p className="font-sans text-sm text-gold tracking-[0.2em] uppercase mb-4" data-id="element-19">
            Los autores
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white" data-id="element-20">
            Guías del viaje
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-21">
          {/* Nicolás Pereira */}
          <motion.div variants={cardVariants} className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 sm:p-10 overflow-hidden" data-id="element-22">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-electric/40 to-transparent" data-id="element-23" />

            <div className="flex flex-col items-center text-center" data-id="element-24">
              {/* Avatar */}
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-electric/20 to-purple-electric/5 border border-purple-electric/20 flex items-center justify-center mb-6" data-id="element-25">
                <span className="font-serif text-2xl font-bold text-purple-electric-light" data-id="element-26">
                  NP
                </span>
              </div>

              <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-27">
                Nicolás Pereira
              </h3>
              <p className="font-sans text-sm text-purple-electric-light/70 tracking-wide uppercase mb-4" data-id="element-28">
                Investigador
              </p>
              <p className="font-sans text-white/40 leading-relaxed" data-id="element-29">
                Investigador de estados expandidos de conciencia y neurociencia
                espiritual. Ha dedicado más de una década a explorar la
                intersección entre la ciencia moderna y las tradiciones místicas
                ancestrales.
              </p>
            </div>
          </motion.div>

          {/* Gabriel Beltrán */}
          <motion.div variants={cardVariants} className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 sm:p-10 overflow-hidden" data-id="element-30">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-31" />

            <div className="flex flex-col items-center text-center" data-id="element-32">
              {/* Avatar */}
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-gold/20 to-gold/5 border border-gold/20 flex items-center justify-center mb-6" data-id="element-33">
                <span className="font-serif text-2xl font-bold text-gold-light" data-id="element-34">
                  GB
                </span>
              </div>

              <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-35">
                Gabriel Beltrán
              </h3>
              <p className="font-sans text-sm text-gold-light/70 tracking-wide uppercase mb-4" data-id="element-36">
                Facilitador
              </p>
              <p className="font-sans text-white/40 leading-relaxed" data-id="element-37">
                Facilitador de ceremonias ancestrales y puente entre mundos. Su
                experiencia directa con las tradiciones amazónicas le permite
                traducir lo inefable en palabras que transforman.
              </p>
            </div>
          </motion.div>
        </motion.div>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-serif text-xl sm:text-2xl text-white/30 text-center mt-12 italic" data-id="element-38">
          "Escrito desde la experiencia directa, no desde la teoría."
        </motion.p>
      </div>
    </section>;
}